// GLSL port of the hull lines in data/ship.ts (keep the two in step), used for
// foam and wake where the hull meets the water.

export const HULL_GLSL = /* glsl */ `
float hStep(float e0, float e1, float x) {
  float t = clamp((x - e0) / (e1 - e0), 0.0, 1.0);
  return t * t * (3.0 - 2.0 * t);
}
float hStemX(float t) { return 16.4 + 3.2 * pow(max(t, 0.0), 1.25); }
float hSternX(float t) { return -16.6 - 1.9 * pow(max(t, 0.0), 1.1); }
float hKeelY(float x) {
  float y = -4.2;
  if (x > 9.0) y += 3.4 * pow((x - 9.0) / 10.6, 2.1);
  if (x < -13.0) y += 0.9 * pow((-13.0 - x) / 5.5, 2.0);
  return y;
}
float hSheerY(float x) {
  return 3.35 + 0.0021 * x * x + 2.0 * hStep(-3.5, -6.8, x) + 0.8 * hStep(9.0, 12.2, x);
}
float hHalfBreadth(float x, float t) {
  float xs = hSternX(t), xb = hStemX(t);
  if (x > xb || x < xs) return -1.0;
  float f;
  if (x >= 1.5) {
    float u = min(1.0, (x - 1.5) / (xb - 1.5));
    f = pow(max(0.0, 1.0 - pow(u, 1.8 + 1.5 * t)), 0.5 + 0.2 * t);
  } else {
    float u = min(1.0, (1.5 - x) / (1.5 - xs));
    float tr = 0.6 * hStep(0.38, 0.95, t);
    f = tr + (1.0 - tr) * pow(max(0.0, 1.0 - pow(u, 2.2 + 2.6 * t)), 0.85 - 0.3 * t);
  }
  float ends = min(1.0, abs(x - 1.5) / 17.0);
  float e = 2.7 - 1.3 * pow(ends, 1.5);
  float sec = t < 0.64 ? 1.0 - pow(1.0 - t / 0.64, e) : 1.0 - 0.12 * pow((t - 0.64) / 0.36, 1.6);
  return 0.2 + 5.1 * sec * f;
}
float hHalfBreadthXY(float x, float y) {
  float k = hKeelY(x);
  float t = (y - k) / (hSheerY(x) - k);
  if (t < 0.0 || t > 1.0) return -1.0;
  return hHalfBreadth(x, t);
}
`;
